

import React from 'react';
import Box from '@mui/material/Box';
import { reduxForm } from 'redux-form';
import { useDispatch, useSelector } from "react-redux";
import Button from '@mui/material/Button';
import FormBuilder, { IMedAppFormField } from '../../../../../form';
import { SubscriptionTier } from '../../../../../../models';
import { required, minLength,  minValue as min, minValue } from '../../../../../form/utils/validations';
import { createModel } from '../../../../store/actions';
import { selectCreatingModel } from '../../../../store/selectors';
import LinearProgress from '@mui/material/LinearProgress';

const intervals = ['days/d', 'months/m', 'years/y'].map(v => {
    const values = v.split('/');
    return {
        label: values[0],
        value: values[1],
    }
});


const SubscriptionTierCreateForm: React.FC<any> = ({ mFields, name, handleSubmit, onSubmit }) => {

    const handleSubmitCallback = (value: any) => {
        onSubmit(value);
    };
    return (
        <form onSubmit={handleSubmit(handleSubmitCallback)}>  <FormBuilder fields={mFields} name={name} />
            <Button type="submit" variant="contained">Continue</Button>
        </form>);
}

const SubscriptionTierCreateReduxForm = reduxForm<any, any>({
    form: 'subscriptiontier-create',
})(SubscriptionTierCreateForm);


const SubscriptionTierCreate: React.FC<{
    subscriptiontier?: SubscriptionTier
}> = ({ subscriptiontier }) => {
 
    const dispatch = useDispatch();
    const creating = useSelector(selectCreatingModel('subscriptiontier'));

    const fields: IMedAppFormField[] = [
        {
            name: 'price',
            label: 'Price',
            type: 'number',
            validate: [required, min(1000)],

        },
        {
            name: 'name',
            label: 'Subscription Tier Name',
            type: 'text',
            validate: [required, minLength(2)],

        },
        {
            name: 'divider',
        
            type: 'text',
            variant: 'divider',
        },
        {
            name: 'description',
            label: 'Subscription Tier Description',
            type: 'text',
            inputExtras: {
                multiline: true,
            },
            validate: [required, minLength(2)],

        

        },

        {
            name: 'subInterval',
            label: 'Subscription Interval',
            type: 'text',
            childFields: [
                {
                    variant: 'select',
                    inputExtras: intervals,
                    name: 'intervalType',
                    defaultValue: 'y',
                    label: 'Interval Type',
                    type: 'text'
                },

                {
                    name: 'interval',
                    placeholder: '1',
                    label: 'Interval',
                    validate: [required, minValue(1)],
                    type: 'number'
                }
            ]
        },
        {
            name: 'maxMembers',
            label: 'Maximum users',
            type: 'number',
            validate: [minValue(1), required],
            inputExtras: {
                defaultValue: 1
            }
        },


   

 
        
    ];


    
    const handleSubmit = (value: any) => {
        const data = {...value, interval: parseInt(value.subInterval.interval, 10), intervalType: value.subInterval.intervalType || 'y'}
        delete data.subInterval;
        data.Status = 1;
        dispatch(createModel({
            model: data,
            modelName: 'subscriptiontier',
        }))
    }

    
    return (
        <Box style={{
            width: '100%'
        }}>
            <Box sx={{
                width: '70%',
                maxWidth: '700px',
                minWidth: '250px',
                marginLeft: '1em'
            }}>
                {(creating) && <LinearProgress />}
                <SubscriptionTierCreateReduxForm mFields={fields} namel="kosy-2" onSubmit={handleSubmit} />
            </Box>
        </Box>
    )
};

export default SubscriptionTierCreate;